import { render, staticRenderFns } from "./SelectFavorite.vue?vue&type=template&id=55b4d164&"
import script from "./SelectFavorite.vue?vue&type=script&lang=ts&"
export * from "./SelectFavorite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports